<template>


  <div data-module="template-faq-section" data-section-type="faqs"
       class="relative overflow-hidden py-8 md:py-16 xl:py-24">
    <div
        class="max-w-screen-2xl mx-auto px-5 md:px-7 lg:px-14 xl:px-20 2xl:px-12 flex flex-wrap justify-between relative mb-4">
      <h2 class="text-3xl w-full text-center font-bold" v-html="title"></h2>
    </div>
    <div class="max-w-screen-2xl px-5 2xl:px-12 py-3 lg:py-4 mx-auto">

      <div
          v-for="(item, index) in listItem"
          :key="index"
          class="flex flex-col max-w-5xl mx-auto pt-6 space-y-6 md:space-y-6"
      >


        <div role="button" class="bg-lifeboost-blue-gray rounded-xl cursor-pointer grid"   @click="toggleAccordion(index)">
          <h3 data-acco-header="1"
              class="px-6 md:px-12 py-4 md:py-6 text-base md:text-lg lg:text-xl xl:text-2xl font-medium flex items-center justify-between">
            <span v-html="item.question" class="basis-full"></span>

            <svg :class="{ hidden: activeAccordionId !== index }" role="presentation" class="ml-3 w-2 md:w-auto basis-4"
                 data-btn-collapse="b6b6a00e-451e-43e8-afc9-eaf86659b774" xmlns="http://www.w3.org/2000/svg"
                 width="7.248" height="2.784" viewBox="0 0 7.248 2.784">
              <path id="Path_746" data-name="Path 746" d="M-8.376-8.184V-5.4h7.248V-8.184Z"
                    transform="translate(8.376 8.184)" fill="#1e2e61"></path>
            </svg>
            <svg :class="{ hidden: activeAccordionId === index }" role="presentation" class="ml-3 w-2 md:w-auto basis-4" data-btn-expand="b6b6a00e-451e-43e8-afc9-eaf86659b774"
                 xmlns="http://www.w3.org/2000/svg" width="13.344" height="13.824" viewBox="0 0 13.344 13.824">
              <path id="Path_745" data-name="Path 745"
                    d="M-9.984-6.288v4.9h4.128v-4.9H-1.2V-10.32H-5.856v-4.9H-9.984v4.9h-4.56v4.032Z"
                    transform="translate(14.544 15.216)" fill="#1e2e61"></path>
            </svg>
          </h3>
          <div data-acco-body="true" class="text-lg space-y-6 px-6 md:px-12 mb-6" :class="['text-lg space-y-6 px-6 md:px-12 mb-6', { hidden: activeAccordionId !== index }]" v-html="item.answer">
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script setup>
defineProps({

  title: {
    type: String,
    default: 'Get Answers to all your Questions',
  },

  listItem: {
    type: Array,
    default: () => [
      {
        id: '1',
        question: 'How does the seasonal sips club work?',
        answer: 'If you sign up for the seasonal membership, you will pay $126 per box each season. Your subscription automatically continues each season unless you decide to cancel before your upcoming bill date.'
      },
      {
        id: '2',
        question: 'What is your cancellation policy?',
        answer: 'You can cancel your next seasonal box up to 5 days in advance before billing. We send out email reminders of your upcoming billing.'
      },
      {
        id: '3',
        question: 'How many bags of coffee are in the Seasonal sips club box?',
        answer: 'Each box comes with six (12-ounce) bags of your choice of beans or ground beans.'
      },
      {
        id: '4',
        question: 'Can I choose what coffee comes in my Seasonal Sips Club box?',
        answer: 'The coffee flavors in each box are fixed and cannot be altered; however, you have the option to select between whole beans or ground coffee.'
      },
      {
        id: '5',
        question: 'How to use your Loyalty points?',
        answer: 'Log in to your account top right of our site and cash in your Perks for rewards.'
      },
      {
        id: '6',
        question: 'What is your refund policy for Seasonal Sips Club?',
        answer: ' Refunds are not available for the Seasonal Sips Club boxes, as all sales are considered final at the time of purchase.'
      },
      {
        id: '7',
        question: 'How do I track the status of my order?',
        answer: 'You can see which orders have shipped and whether you have future shipments scheduled by logging into <a href="https://lifeboostcoffee.com/account/login?return_url=%2Faccount" target="_blank" class="text-link">your account</a>. When we ship each box, you\'ll receive a shipment notification by email with your tracking link as well! If you have any questions about an order, you can also contact customer service.'
      },

    ],
  },




})

const activeAccordionId = ref(null);

const toggleAccordion = (blockId) => {
  if (activeAccordionId.value === blockId) {
    activeAccordionId.value = null;
  } else {
    activeAccordionId.value = blockId;
  }
};


defineBuilderComponent({
    friendlyName: "Questions",
    canHaveChildren: true,
    inputs: [
        {
            name: "title",
            type: "richText",
            defaultValue: "Get Answers to all your Questions"
        },
        {
            name: "listItem",
            type: "list",
            subFields: [
                {
                    name: "id",
                    type: "text"
                },
                {
                    name: "question",
                    type: "richText"
                },
                {
                    name: "answer",
                    type: "richText"
                }
            ],
            defaultValue: [
                {
                    id: "1",
                    question: "How does the seasonal sips club work?",
                    answer: "If you sign up for the seasonal membership, you will pay $126 per box each season. Your subscription automatically continues each season unless you decide to cancel before your upcoming bill date."
                },
                {
                    id: "2",
                    question: "What is your cancellation policy?",
                    answer: "You can cancel your next seasonal box up to 5 days in advance before billing. We send out email reminders of your upcoming billing."
                },
                {
                    id: "3",
                    question: "How many bags of coffee are in the Seasonal sips club box?",
                    answer: "Each box comes with six (12-ounce) bags of your choice of beans or ground beans."
                },
                {
                    id: "4",
                    question: "Can I choose what coffee comes in my Seasonal Sips Club box?",
                    answer: "The coffee flavors in each box are fixed and cannot be altered; however, you have the option to select between whole beans or ground coffee."
                },
                {
                    id: "5",
                    question: "How to use your Loyalty points?",
                    answer: "Log in to your account top right of our site and cash in your Perks for rewards."
                },
                {
                    id: "6",
                    question: "What is your refund policy for Seasonal Sips Club?",
                    answer: " Refunds are not available for the Seasonal Sips Club boxes, as all sales are considered final at the time of purchase."
                },
                {
                    id: "7",
                    question: "How do I track the status of my order?",
                    answer: "You can see which orders have shipped and whether you have future shipments scheduled by logging into <a href=\"https://lifeboostcoffee.com/account/login?return_url=%2Faccount\" target=\"_blank\" class=\"text-link\">your account</a>. When we ship each box, you'll receive a shipment notification by email with your tracking link as well! If you have any questions about an order, you can also contact customer service."
                }
            ]
        }
    ]
});
</script>


